import React from "react";
import { BUSINESS_TYPE, BusinessType } from "./businessType";
import FoodTypeIcon from "@me-team/common/src/images/restaurant-type.svg";
import ServiceTypeIcon from "@me-team/common/src/images/salon-type.svg";
import OtherTypeIcon from "@me-team/common/src/images/general-type.svg";
import { TFunction } from "i18next";

export interface BusinessTypeOption {
    value: BusinessType;
    label: string;
    description: string;
    icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
}

export const getBusinessTypeOptions = (t: TFunction): BusinessTypeOption[] => [
    {
        value: BUSINESS_TYPE.SERVICE,
        label: t("businessType.Service business"),
        description: t(
            "For beauty salons, studios, craftsmen and service businesses with online booking and customer accounting."
        ),
        icon: ServiceTypeIcon,
    },
    {
        value: BUSINESS_TYPE.FOOD,
        label: t("businessType.Food business"),
        description: t("For cafes, restaurants, bars and other establishments that use QR menus."),
        icon: FoodTypeIcon,
    },
    {
        value: BUSINESS_TYPE.OTHER,
        label: t("businessType.Other"),
        description: t("Universal modules for business with flexible configuration."),
        icon: OtherTypeIcon,
    },
];
